import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';
import Button from '../ui/Controls/Button';
import setQaAttribute from '../../helpers/setQaAttribute';
import { CHAT_POPUP, CHAT_POPUP_CHILDREN, CHAT_POPUP_CLOSE } from '../../constants/qaAttributes';

interface IChatPopup {
  children: ReactNode | string;
  closeAction: () => void;
}
const ChatPopup: FC<IChatPopup> = ({ children, closeAction }) => (
  <div className={classNames(css.chatPopup)} {...setQaAttribute(CHAT_POPUP)}>
    <div className={classNames(css.textBlock)} {...setQaAttribute(CHAT_POPUP_CHILDREN)}>
      {children}
    </div>
    <div className={classNames(css.closeAction)}>
      <Button
        onClick={closeAction}
        icon="20--cancel"
        iconSize="20"
        radius="circle"
        variant="icon"
        {...setQaAttribute(CHAT_POPUP_CLOSE)}
      />
    </div>
  </div>
);

export default ChatPopup;
